module.exports = {"440705001":"会城街道办","440705101":"大泽镇","440705102":"司前镇","440705103":"罗坑镇","440705104":"双水镇","440705105":"崖门镇","440705106":"沙堆镇","440705107":"古井镇","440705108":"三江镇","440705109":"睦洲镇","440705110":"大鳌镇","440705450":"圭峰管理委员会","440705451":"银湖湾管理委员会","440705470":"新会经济开发区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440705.json
// module id = 1992
// module chunks = 0